module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top",
      "effect": "light"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('img', {
    attrs: {
      "src": "/static/help/mobileapp.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info",
      "size": "mini"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  }), _vm._v(" Pomocnicze informacje dotyczące grafik\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kolor tła",
      "error": _vm.errors['bg_color']
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.form.bg_color),
      callback: function($$v) {
        _vm.$set(_vm.form, "bg_color", $$v)
      },
      expression: "form.bg_color"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Treść",
      "error": _vm.errors[_vm.addLanguageSuffix('content')]
    }
  }, [_c('wyswig-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('content')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('content'), $$v)
      },
      expression: "form[addLanguageSuffix('content')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Link iOS"
    }
  }, [_c('link-component', {
    attrs: {
      "errors": _vm.errors.ios_link
    },
    model: {
      value: (_vm.form.ios_link),
      callback: function($$v) {
        _vm.$set(_vm.form, "ios_link", $$v)
      },
      expression: "form.ios_link"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Link Android"
    }
  }, [_c('link-component', {
    attrs: {
      "errors": _vm.errors.android_link
    },
    model: {
      value: (_vm.form.android_link),
      callback: function($$v) {
        _vm.$set(_vm.form, "android_link", $$v)
      },
      expression: "form.android_link"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Lewe tło",
      "error": _vm.errors['left_image']
    }
  }, [_c('image-input-component', {
    model: {
      value: (_vm.form.left_image),
      callback: function($$v) {
        _vm.$set(_vm.form, "left_image", $$v)
      },
      expression: "form.left_image"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Prawe tło",
      "error": _vm.errors['right_image']
    }
  }, [_c('image-input-component', {
    model: {
      value: (_vm.form.right_image),
      callback: function($$v) {
        _vm.$set(_vm.form, "right_image", $$v)
      },
      expression: "form.right_image"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Zdjęcie telefonu",
      "error": _vm.errors['phone_image']
    }
  }, [_c('image-input-component', {
    model: {
      value: (_vm.form.phone_image),
      callback: function($$v) {
        _vm.$set(_vm.form, "phone_image", $$v)
      },
      expression: "form.phone_image"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09d0c839"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/forms/MobileAppWidget.vue
// module id = 712
// module chunks = 0